import { render, staticRenderFns } from "./EventBoothTable.vue?vue&type=template&id=b7809998"
import script from "./EventBoothTable.vue?vue&type=script&lang=js"
export * from "./EventBoothTable.vue?vue&type=script&lang=js"
import style0 from "./EventBoothTable.vue?vue&type=style&index=0&id=b7809998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports